__turbopack_context__.v({
  "blueBtn": "JqwQJW_blueBtn",
  "chatSpecialist": "JqwQJW_chatSpecialist",
  "leftPanel": "JqwQJW_leftPanel",
  "midPanel": "JqwQJW_midPanel",
  "midPanelPhone": "JqwQJW_midPanelPhone",
  "rightPanel": "JqwQJW_rightPanel",
  "root": "JqwQJW_root",
  "striked": "JqwQJW_striked",
  "subtitleTextBtn": "JqwQJW_subtitleTextBtn",
  "totalPriceSingle": "JqwQJW_totalPriceSingle",
});
